function NavMenu(args) {
    "use strict";

    this.version = "1.5";

    var defargs = {
        window: null,
        document: null,
        activemenu_class: ".current-menu-item, .current-menu-ancestor",
        elementid: null,
        menuid: "",
        menucontainerid: "",
        menuitemsid: ""
    };

    var scroller = null;    

    $.extend(defargs, args);

    if (defargs.elementid === null || defargs.window === null || defargs.document === null) { throw new Error("Invalid arguments passed to NavMenu constructor."); }
    
    if (defargs.menuid.length === 0) {
        defargs.menuid = "#navmenu-" + Math.round(1000 * Math.random());
    }
    
    defargs.menucontainerid = defargs.menuid + "-container";
    defargs.menuitemsid = defargs.menuid + "-items";  

    initialize();
    
    this.getMenuItemsID = function () {
        return defargs.menuitemsid;
    };
    
    var redrawMenu = function() {
        if (scroller !== null) {
            scroller.redrawScrollButtons();
        }
    };

    this.redrawMenu = redrawMenu;
       
    function initialize() {        
        // Wrap menuitems
        $(defargs.elementid).html("<div id='"+defargs.menucontainerid.replace("#", "")+"' class='navmenu-container'><div id='"+defargs.menuitemsid.replace("#", "")+"' class='navmenu-items'>"+$(defargs.elementid).html()+"</div></div>");
        
        // Check what the current menu item is
        checkCurrentMenu();

        // Disable menu items containing disabled links (#*) and replace empty links (#)
        var links = $("a", defargs.menuitemsid);

        for (var x = 0; x < links.length; x++) {
            if ($(links[x]).attr("href") === "#*") {
                $(links[x]).parent("li").addClass("disabled");

                $(links[x]).replaceWith($(links[x]).html());
            }
        }
        
        // Set menu ID
        var navmen = $(">ul", defargs.menuitemsid).get(0);
        $(navmen).attr("id", defargs.menuid.replace("#", ""));

        // Setup navigation
        setupMenu();

        return true;
    }

    function checkCurrentMenu() {
        var itms = $("li", defargs.menuitemsid);

        $(itms).each(function (x) {
            var url1 = $(">a", this).attr("href");
            if (url1 === undefined) { url1 = ""; }

            url1 = removeLastSlash(url1.toLowerCase());
            var url2 = removeLastSlash(document.URL.toLowerCase());

            if (url1 === url2) {
                if (!$(this).hasClass("current-menu-item")) {
                    $(this).addClass("current-menu-item");

                    checkCurrentMenuParent(this);
                }
            }
        });
    }

    function removeLastSlash(url) {
        if (url.substr(url.length - 1, 1) === "/") { return url.substr(0, url.length - 1); }

        return url;
    }

    function checkCurrentMenuParent(itm) {
        var men = $(itm).parent().closest("li");

        if (men.length > 0) {
            $(men).addClass("current-menu-parent");
            $(men).addClass("current-menu-ancestor");

            checkCurrentMenuParent(men);
        }
    }

    function wrapMenuItem(menitm) {
        if ($(">div.menu-item-txt", menitm).length === 0) {
            // Wrap menu item text and submenu (if present) in <div>
            var html = $(menitm).html();
            var html2 = html.toLowerCase();

            var mentxt = html.substring(0, pos);
            var smen = "";

            var pos = html2.indexOf("<ul");
            if (pos !== -1) {
                mentxt = html.substring(0, pos);
                smen = html.substr(pos, (html.length - pos));
            }

            html = "<div class='menu-item-txt'>" + mentxt + "</div>";
            if (smen.length > 0) { html += "<div class='submenu'>" + smen + "</div>"; }
            $(menitm).html(html);
            
            return true;
        }
        
        return false;        
    }
    
    function setupMenu() {
        // First wrap li content in divs, keep in the loop as long as we change the DOM so we don't miss any 
        while (true) {
            var change = false;
            var menitms = $("li", defargs.menuid);
            
            for (var i = 0; i < menitms.length; i++) {
                if (wrapMenuItem(menitms[i])) { change = true; }
            }
            
            if (!change) { break; }
        }
                
        $("li", defargs.menuid).each(function (x) {
            var li = this;

            $(this).addClass("menu-item");  
            
            if ($(this).children(".submenu").length > 0) {
                // Expand or collapse submenu when clicked
                $(">div.menu-item-txt", this).click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    toggleSubmenu(li);
                });
                                
                $(this).addClass("has-submenu");        

                $(">.submenu", this).css("height", "0");
                $(">.submenu", this).css("overflow", "hidden");
                $(">.submenu", this).css("display", "none");
            }
            else {               
                $(">div.menu-item-txt", this).click(function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    if (!$(li).is(defargs.activemenu_class)) {
                        var found = $(li).find(">div >a");

                        if (found.length !== 0) {
                            window.location.href = $(">div >a", li).attr("href");
                        }
                    }
                });                 
            }

            // fade in and out when cursor enters
            $(">div.menu-item-txt", this).on("mouseenter", function () {
                $(".menu-item-hover").not(li).removeClass("menu-item-hover");
                $(li).addClass("menu-item-hover"); 
            });

            $(">div.menu-item-txt", this).on("mouseleave", function () {
                $(li).removeClass("menu-item-hover");
            });            

            var found = $(">div >a", this);
            if (found.length !== 0) {
                $(">div >a", this).focusin(
                    function () {
                        var menitm = $(this).parent().closest("li");

                        $(menitm).addClass("menu-item-hover");
                    });

                $(">div >a", this).focusout(
                    function () {
                        var menitm = $(this).parent().closest("li");

                        $(menitm).removeClass("menu-item-hover");
                    });

                $(">div >a", this).keypress(
                    function (event) {
                        if (event.which === 13) {
                            var menitm = $(this).parent().closest("li");

                            if ($(menitm).hasClass("has-submenu")) {
                                event.preventDefault();
                                toggleSubmenu(menitm);
                            }
                        }
                    });
            }
        });

        scroller = new ElmScroller({
            window: defargs.window,
            document: defargs.document,
            element: $(defargs.menuitemsid),
            elementparent: $(defargs.menucontainerid),
            direction_y: true
        });   
    }
    
    function toggleSubmenu(menitm) {
        if (!$(menitm).hasClass("submenu-open")) {
            var subm = $(">.submenu", menitm);
            subm.css("height", "auto");
            var h = subm.css("height");
            subm.css("height", 0);
            subm.css("display", "block");
            subm.css("opacity", 0);
            
            TweenMax.to(subm, 0.3, { height: h, opacity: 1, ease: Quint.easeOut, 
            onComplete: function () { 
                subm.css("height", "auto"); 
                redrawMenu(); 
                }
            });

            $(menitm).addClass("submenu-open");
        }
        else {
            var subm2 = $(">.submenu", menitm);
            TweenMax.to(subm2, 0.3, { height: 0, opacity: 0, ease: Quint.easeOut, 
            onComplete: function () { 
                subm2.css("display", "none"); 
                redrawMenu(); 
                }
            });            

            $(menitm).removeClass("submenu-open");
        }
    }
}

